export const durationOptions = [
  {
    value: '30 min',
    id: 30,
  },
  {
    value: '45 min',
    id: 45,
  },
  {
    value: '60 min',
    id: 60,
  },
  {
    value: '75 min',
    id: 75,
  },
  {
    value: '90 min',
    id: 90,
  },
  {
    value: '120 min',
    id: 120,
  },
  {
    value: '180 min',
    id: 180,
  },
];

export const currentYear = new Date().getFullYear();

export const hoursOptions = [
  { value: 'Closed', valueFormatted: 'closed' },
  { value: '5:00 am', valueFormatted: '05:00:00' },
  { value: '5:15 am', valueFormatted: '05:15:00' },
  { value: '5:30 am', valueFormatted: '05:30:00' },
  { value: '5:45 am', valueFormatted: '05:45:00' },
  { value: '6:00 am', valueFormatted: '06:00:00' },
  { value: '6:15 am', valueFormatted: '06:15:00' },
  { value: '6:30 am', valueFormatted: '06:30:00' },
  { value: '6:45 am', valueFormatted: '06:45:00' },
  { value: '7:00 am', valueFormatted: '07:00:00' },
  { value: '7:15 am', valueFormatted: '07:15:00' },
  { value: '7:30 am', valueFormatted: '07:30:00' },
  { value: '7:45 am', valueFormatted: '07:45:00' },
  { value: '8:00 am', valueFormatted: '08:00:00' },
  { value: '8:15 am', valueFormatted: '08:15:00' },
  { value: '8:30 am', valueFormatted: '08:30:00' },
  { value: '8:45 am', valueFormatted: '08:45:00' },
  { value: '9:00 am', valueFormatted: '09:00:00' },
  { value: '9:15 am', valueFormatted: '09:15:00' },
  { value: '9:30 am', valueFormatted: '09:30:00' },
  { value: '9:45 am', valueFormatted: '09:45:00' },
  { value: '10:00 am', valueFormatted: '10:00:00' },
  { value: '10:15 am', valueFormatted: '10:15:00' },
  { value: '10:30 am', valueFormatted: '10:30:00' },
  { value: '10:45 am', valueFormatted: '10:45:00' },
  { value: '11:00 am', valueFormatted: '11:00:00' },
  { value: '11:15 am', valueFormatted: '11:15:00' },
  { value: '11:30 am', valueFormatted: '11:30:00' },
  { value: '11:45 am', valueFormatted: '11:45:00' },
  { value: '12:00 pm', valueFormatted: '12:00:00' },
  { value: '12:15 pm', valueFormatted: '12:15:00' },
  { value: '12:30 pm', valueFormatted: '12:30:00' },
  { value: '12:45 pm', valueFormatted: '12:45:00' },
  { value: '1:00 pm', valueFormatted: '13:00:00' },
  { value: '1:15 pm', valueFormatted: '13:15:00' },
  { value: '1:30 pm', valueFormatted: '13:30:00' },
  { value: '1:45 pm', valueFormatted: '13:45:00' },
  { value: '2:00 pm', valueFormatted: '14:00:00' },
  { value: '2:15 pm', valueFormatted: '14:15:00' },
  { value: '2:30 pm', valueFormatted: '14:30:00' },
  { value: '2:45 pm', valueFormatted: '14:45:00' },
  { value: '3:00 pm', valueFormatted: '15:00:00' },
  { value: '3:15 pm', valueFormatted: '15:15:00' },
  { value: '3:30 pm', valueFormatted: '15:30:00' },
  { value: '3:45 pm', valueFormatted: '15:45:00' },
  { value: '4:00 pm', valueFormatted: '16:00:00' },
  { value: '4:15 pm', valueFormatted: '16:15:00' },
  { value: '4:30 pm', valueFormatted: '16:30:00' },
  { value: '4:45 pm', valueFormatted: '16:45:00' },
  { value: '5:00 pm', valueFormatted: '17:00:00' },
  { value: '5:15 pm', valueFormatted: '17:15:00' },
  { value: '5:30 pm', valueFormatted: '17:30:00' },
  { value: '5:45 pm', valueFormatted: '17:45:00' },
  { value: '6:00 pm', valueFormatted: '18:00:00' },
  { value: '6:15 pm', valueFormatted: '18:15:00' },
  { value: '6:30 pm', valueFormatted: '18:30:00' },
  { value: '6:45 pm', valueFormatted: '18:45:00' },
  { value: '7:00 pm', valueFormatted: '19:00:00' },
  { value: '7:15 pm', valueFormatted: '19:15:00' },
  { value: '7:30 pm', valueFormatted: '19:30:00' },
  { value: '7:45 pm', valueFormatted: '19:45:00' },
  { value: '8:00 pm', valueFormatted: '20:00:00' },
  { value: '8:15 pm', valueFormatted: '20:15:00' },
  { value: '8:30 pm', valueFormatted: '20:30:00' },
  { value: '8:45 pm', valueFormatted: '20:45:00' },
  { value: '9:00 pm', valueFormatted: '21:00:00' },
  { value: '9:15 pm', valueFormatted: '21:15:00' },
  { value: '9:30 pm', valueFormatted: '21:30:00' },
  { value: '9:45 pm', valueFormatted: '21:45:00' },
  { value: '10:00 pm', valueFormatted: '22:00:00' },
  { value: '10:15 pm', valueFormatted: '22:15:00' },
  { value: '10:30 pm', valueFormatted: '22:30:00' },
  { value: '10:45 pm', valueFormatted: '22:45:00' },
  { value: '11:00 pm', valueFormatted: '23:00:00' },
  { value: '11:15 pm', valueFormatted: '23:15:00' },
  { value: '11:30 pm', valueFormatted: '23:30:00' },
  { value: '11:45 pm', valueFormatted: '23:45:00' },
];

export const weekdays = [
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday',
  'Sunday',
];

export const weekdaysIndex = {
  Sunday: 0,
  Monday: 1,
  Tuesday: 2,
  Wednesday: 3,
  Thursday: 4,
  Friday: 5,
  Saturday: 6,
};

export const displayErrorMessage = ({ errorData, errorMessage }) => {
  if (errorMessage) {
    return errorMessage;
  }

  if (typeof errorData === 'string') {
    if (errorData === 'mfa does not exist') {
      return 'The code you entered is not valid! Try resending a new code.';
    }
  }

  const error = errorData?.[0] || {};

  return (
    error.message ||
    'Oops! Something went wrong. Please contact us at support@mypawcare.com.'
  );
};

export const paymentsColumnsOrder = [
  'client',
  'payment',
  'amount',
  'date',
  'status',
];

export const paymentsColumns = [
  {
    name: 'Client',
    key: 'client',
  },
  {
    name: 'Payment',
    key: 'payment',
  },
  {
    name: 'Amount',
    key: 'amount',
  },
  {
    name: 'Date',
    key: 'date',
  },
  {
    name: 'Status',
    key: 'status',
  },
];

export const teamColumnsOrder = [
  'groomer',
  'animals',
  'email',
  'phone',
  'action',
];
export const teamColumns = [
  {
    name: 'Groomer',
    key: 'groomer',
  },
  {
    name: 'Animals',
    key: 'animals',
  },
  {
    name: 'Email',
    key: 'email',
  },
  {
    name: 'Phone',
    key: 'phone',
  },
  {
    name: 'Action',
    key: 'action',
  },
];

export const clientsColumnsOrder = [
  'petName',
  'owner',
  'email',
  'phone',
  'visits',
];

export const clientsColumns = [
  {
    name: 'Pet name',
    key: 'petName',
  },
  {
    name: 'Owner',
    key: 'owner',
  },
  {
    name: 'Email',
    key: 'email',
  },
  {
    name: 'Phone',
    key: 'phone',
  },
  {
    name: 'Visits',
    key: 'visits',
    grow: false,
  },
];

export const catTypeId = 1;
export const dogTypeId = 2;
// Made up ID to reference both cat and dog ID's
export const catAndDogTypeId = 10;

export const viewAllGroomersOption = {
  links: null,
  name: 'All',
  uuid: 'all',
  isLocation: true,
};
